// config for screensize thresholds and settings
var config = {
    multiSize: {
        large: 1800,
        medium: 9000,
        small: 300
    }
};

var windowWidth;

/**
 * On page load
 **/
$(document).ready( function(){
	// Start your website!
	// console.log('Loaded!');
    windowWidth = $(window).width();
    //console.log(windowWidth);
	PageSetup();
    SocialShare();
});

$(window).resize(function(){
    ResponsiveBG();
});

$(window).scroll( function(evt) {
    ResponsiveBG();
});


function PageSetup(){
    MobileNav();
    if(windowWidth <= 550){
        ToggleContent();
    }
    ToggleContent();
    ResponsiveBG();    
    ToggleImageCaptions();
}

function MobileNav(){
    $('.hamburglar').click( function(){
        $(this).toggleClass('open');
        $('.mainnav').toggleClass('open');
        // $('.mainnav').slideToggle();
    });
}

function ToggleContent(){
    $('.expander').click(function(e){
        $(this).toggleClass('open');
        e.preventDefault();
        $(this).parent('.foo').parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).parent('.foo').toggleClass('open');
    });
}


$(window).resize(function(){
    windowWidth = $(window).width();
    if(windowWidth <= 550){
        ToggleContent();
    }
});

/**
 * Multi-size graphics
 * These allow us to load the relevant image size, depending on the size of the screen
 * By default we load a mobile-sized image initially, and swap to larger pics if applicable
 **/
function ResponsiveBG(){

    $('.responsive-bg').each( function( key, panel ){

            panel = $(panel);
            var panelWidth = $(window).outerWidth();
            
            if( panelWidth > config.multiSize.medium && panel.data('large') ){

                if( panel.is( 'img') ) {
                    panel.delay(1000).attr( 'src', panel.data('large') );
                } else {
                    panel.delay(1000).css({ 'background-image': 'url('+ panel.data('large') +')' });
                }
                
            }else if( panelWidth > config.multiSize.small && panel.data('medium') ){
                
                if( panel.is( 'img') ) {
                    panel.attr( 'src', panel.data('medium') );
                } else {
                    panel.css({'background-image': 'url('+ panel.data('medium') +')' });
                }
                
            }else if(panel.data('small')){
                
                if( panel.is( 'img') ) {
                    panel.attr( 'src', panel.data('small') );
                } else {
                    panel.css({'background-image': 'url('+ panel.data('small') +')' });
                }

            }

            panel.removeClass('loading');
    
    });
}

/**
 * social share
 * get details from link attributes and construct popup
 **/
function SocialShare(){
    
    // On clicks of media icons
    $('.share-popup').click(function(){
        var sharelink = $(this).attr('data-sharelink');
        var url = $(this).attr('data-url');
        console.log(sharelink + url);
        window.open(sharelink + url,'_blank','height=400,width=600,menubar=0,resizable=1,toolbar=0,location=0',true);
    });
}


function ToggleImageCaptions(){
    
    $('.credited-image .toggle').stop().click(function(){
        
        var target = $(this).siblings('.details');
        
        if($(this).hasClass('fadein')){
            target.fadeIn(100);
        }else{
            target.fadeOut(100);
        }
        
        $(this).toggleClass('fadein fadeout');
        
    });
    
}



  /* ---------------------------------------------
        Google Analytics
    --------------------------------------------- */
    jQuery('a').click(function(){
        var href =  jQuery(this).attr('href');

        if(/\.pdf/.test(href)){
            _gaq.push(['_trackEvent', 'PDF Document', 'Download',href]);
        }

        if(/\.doc$|\.docx$/.test(href)){
            _gaq.push(['_trackEvent', 'Word Document', 'Download',href]);
        }
    });